export enum WeightUnit {
  LB = 'LB',
  KG = 'KG',
}

export enum TypeBagsWeight {
  _10KG = 1,
  _15KG,
  _20KG,
  _25KG,
  _32KG,
}

export enum BagsWeightCode {
  "15KG" = "07X",
  "20KG" = "0LX,0JH,0LL,02T,XB5,XB6,XB7",
  "25KG" = "08K,0CD,0CE,0CF,0CG,0CH,0CI"
}

/**
 * Alias de códigos que el micro de eligibility/ancillaries envía y que
 * representan la MISMA pieza que un código canónico. Se normalizan al
 * construir el bagStack para evitar contar la misma maleta dos veces.
 *
 * 0IA (código de UI) === 08K (ancillary: "1ST BAG UP TO 55LB 25KG"),
 * la 1a pieza de equipaje documentado de 25kg.
 *
 * Nota: este mapa aplica solo a códigos que el kiosko construye/compara
 * internamente. El texto de remarks emitido por sistemas externos (p. ej.
 * "IBT...0IA") NO debe normalizarse con este mapa: es dato externo.
 */
export const BAG_CODE_ALIASES: Readonly<Record<string, string>> = {
  '0IA': '08K',
};

export enum BagsWeightForWeight {
  "10KG" = "10",
  "15KG" = "15",
  "20KG" = "20",
  "25KG" = "25",
  "32KG" = "32"
}

export enum StatusBag{
  NONE = "NONE",
  INCLUDE = "include",
  REDEEMED = "redeemed",
  REDEEMED_APPLIED = "redeemedApplied",
  PAID = "paid",
  TO_PAY = "toPay",
  DOCUMENT = "Document",
  ON_HOLD = "onhold"
}

export enum StatusBagCarryOn{
  NONE = 0,
  USED = 1,
  USED_WITHOUT_WEIGHT = 2,
}


export enum ResultModalRedeem {
  SUCCESS,
  NO_REDEEM,
  ERROR
}

export enum BagCommercialName {
  CARRY_ON_15KG = 'CARRY ON UP TO 15KG',
}

export type RedeemMethod = 'cobrand' | 'tier' | 'corporate' | 'f&f';
